import { render, staticRenderFns } from "./Followup.vue?vue&type=template&id=21b0c4d0&"
import script from "./Followup.vue?vue&type=script&lang=js&"
export * from "./Followup.vue?vue&type=script&lang=js&"
import style0 from "./Followup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports